import * as yup from "yup"
import { useCallback } from "react"
import {
  useCompanyConnectorControllerAuthenticateCompanyConnectorMutation as useCompanyConnectorAuthMutation,
  useGuestCompanyConnectorControllerAuthenticateMutation as useGuestCompanyConnectorAuthMutation,
} from "~/ui-rtk/api/companyConnectorApi"
import { GuestTokenParam } from "../types"

export const validationSchema = yup.object().shape({
  appKey: yup.string().required("App Key is required!"),
  secretKey: yup.string().required("Secret Key is required!"),
})

export type FormValues = yup.InferType<typeof validationSchema>

const initialValues: FormValues = {
  appKey: "",
  secretKey: "",
}

type Params = {
  authCode: string
  companyConnectorId: string
} & GuestTokenParam

export const useConnect = () => {
  const [authAsync, { isLoading: isAuthLoading }] =
    useCompanyConnectorAuthMutation()
  const [guestAuthAsync, { isLoading: isGuestAuthLoading }] =
    useGuestCompanyConnectorAuthMutation()

  const authenticate = useCallback(async (params: Params) => {
    const { isGuest, companyConnectorId, authCode } = params
    if (isGuest) {
      await guestAuthAsync({
        id: companyConnectorId,
        token: params.token,
        authenticateCompanyConnectorDto: { authCode },
      }).unwrap()
    } else {
      await authAsync({
        id: companyConnectorId,
        authenticateCompanyConnectorDto: { authCode },
      }).unwrap()
    }
  }, [])

  const isLoading = isAuthLoading || isGuestAuthLoading

  return {
    initialValues,
    validationSchema,
    authenticate,
    isLoading,
  }
}
